module.exports = __webpack_public_path__ + "static/media/Jennifer.485f9c69.png";